import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';
import { getAccountEarmarkType, getAccountEarmarkTooltip } from './AccountsOverviewSelector';

export const selectAccount = (
  graphAccounts,
  id,
  workflowId,
  clientId,
  name = null,
  isSingleSelection = false,
) => dispatch => {
  dispatch(
    updateData(
      {
        [BACKEND_KEY]: graphAccounts.map(graphAccount => {
          if (graphAccount.AccountId === id || graphAccount.frontEndId === id) {
            return {
              ...graphAccount,
              AccountEarmark: graphAccount.AccountEarmark.concat([
                {
                  Type: getAccountEarmarkType(workflowId, name),
                  Tooltip: getAccountEarmarkTooltip(workflowId, name),
                },
              ]),
            };
          }

          if (isSingleSelection) {
            return {
              ...graphAccount,
              AccountEarmark: graphAccount.AccountEarmark.filter(
                ({ Type }) =>
                  Type !== getAccountEarmarkType(workflowId, name) && Type !== 'AllGoals',
              ),
            };
          }

          return graphAccount;
        }),
      },
      workflowId,
      clientId,
    ),
  );
};

export const deselectAccount = (
  graphAccounts,
  id,
  workflowId,
  clientId,
  name = null,
) => dispatch => {
  dispatch(
    updateData(
      {
        [BACKEND_KEY]: graphAccounts.map(graphAccount => {
          if (graphAccount.AccountId === id || graphAccount.frontEndId === id) {
            return {
              ...graphAccount,
              AccountEarmark: graphAccount.AccountEarmark.filter(
                ({ Type }) =>
                  Type !== getAccountEarmarkType(workflowId, name) && Type !== 'AllGoals',
              ),
            };
          }
          return graphAccount;
        }),
      },
      workflowId,
      clientId,
    ),
  );
};

export const deleteAccount = (graphAccounts, id, workflowId, clientId) => dispatch => {
  dispatch(
    updateData(
      {
        [BACKEND_KEY]: graphAccounts.map(graphAccount => {
          if (graphAccount.AccountId === id || graphAccount.frontEndId === id) {
            return {
              ...graphAccount,
              IsDeleted: true,
            };
          }
          return graphAccount;
        }),
      },
      workflowId,
      clientId,
    ),
  );
};
